import { OnInit, OnDestroy, Optional, Inject  } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService, DomainContext, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { vendors } from '../../fixtures/mock-da-vendor-data';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-da-overview',
    templateUrl: './dojo-da-overview.component.html'
})
export class DojoDaOverviewComponent implements OnInit, AfterViewInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    isAccessOnlyEnabled: boolean = false;
    hideDAOverview: boolean = false;
	isMobile: boolean = false;
	isGenric: boolean = false;
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.ibdConfigMap.IBD && (appSettings.ibdConfigMap.IBD === '6P1' || appSettings.ibdConfigMap.IBD === '5HR' )) {
            this.isAccessOnlyEnabled = true;
        }
        this.isMobile = (appSettings.deviceType === 'mobile');
        this.isGenric = appSettings.ibdConfigMap.generic;        
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
			if (!(this.isMobile && this.isGenric)){
				this.getDAOverviewParams();
			}
        });
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('daOverview');
        }
    }

    getVendors() {
        // TODO: Swap this once NXI rest ready.
        // this.nxiRestService.getDaVendors().subscribe(
        //     response => {
        //         return response;
        //     }
        // );
        return vendors;
    }

    renderDojoWidget(daOverviewParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderDaOverview(daOverviewParams);
        }
    }

    getDAOverviewParams() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiRestService.getNxiRestUrlResponse(this.nxiRestService.serviceUrl + '/portfolio/daVendorsList').subscribe(
                resp => {
                    console.log('Retrieved common REST DA Overview widgets param : ', resp.response);
                    if (resp.response && !resp.response.hasDaAccount && this.isAccessOnlyEnabled) {
                        this.hideDAOverview = true;
                    }
                    if (resp.response) {
                        for (let i = 0; i < resp.response.vendors.length; i++) {
                            resp.response.vendors[i].preloginUrl = '/nxi/' + resp.response.vendors[i].preloginUrl ;
                            resp.response.vendors[i].postloginAccessUrl = '/nxi/' + resp.response.vendors[i].postloginAccessUrl ;
                            resp.response.vendors[i].postloginExploreUrl = '/nxi/' + resp.response.vendors[i].postloginExploreUrl ;
                        }
                        resp.response.pageName = 'overview';
                        resp.response.renderInQuickLinkMode = true;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }

}
